(() => {
  function nativeOptionButton(form, position, value) {
    if (!form || !position || !value) return null;
    const fieldset = form.querySelector(`[data-option-position="${CSS.escape(String(position))}"]`);
    if (!fieldset) return null;
    return [...fieldset.querySelectorAll('[data-option-value]')].find((button) => button.dataset.optionValue === value) || null;
  }

  function currentVariant(form) {
    if (form?.currentVariant) return form.currentVariant;
    const id = form?.querySelector('[data-variant-id]')?.value;
    return form?.variants?.find((variant) => String(variant.id) === String(id)) || form?.variants?.[0] || null;
  }

  function variantForChoice(form, position, value) {
    const active = currentVariant(form);
    const index = Number(position) - 1;
    if (!active || index < 0 || !Array.isArray(active.options)) return null;
    const options = [...active.options];
    options[index] = value;
    if (typeof form.findVariant === 'function') return form.findVariant(options);
    return form.variants?.find((variant) => Array.isArray(variant.options) && variant.options.length === options.length && variant.options.every((candidate, optionIndex) => candidate === options[optionIndex])) || null;
  }

  function isNativeSelected(button) {
    return Boolean(button && (button.classList.contains('is-selected') || button.getAttribute('aria-pressed') === 'true'));
  }

  function syncCards(guide, form) {
    const directVariant = currentVariant(form);
    guide.querySelectorAll('[data-wn-smart-group]').forEach((group) => {
      let selectedLabel = '';
      group.querySelectorAll('[data-wn-guide-option]').forEach((card) => {
        const position = Number(card.dataset.wnGuidePosition || 0);
        const value = card.dataset.wnGuideValue || '';
        const native = nativeOptionButton(form, position, value);
        const directCandidate = native ? null : variantForChoice(form, position, value);
        const selected = native
          ? isNativeSelected(native)
          : Boolean(directVariant && directVariant.options?.[position - 1] === value);
        const soldOut = native
          ? Boolean(native.classList.contains('is-sold-out'))
          : Boolean(directCandidate && !directCandidate.available);
        const unavailable = !native && !directCandidate;
        const marketHidden = Boolean(native && (native.hidden || native.getAttribute('aria-hidden') === 'true'));
        const disabled = marketHidden || unavailable || (soldOut && !selected);

        card.hidden = marketHidden;
        card.classList.toggle('is-selected', selected && !marketHidden);
        card.classList.toggle('is-sold-out', soldOut || unavailable);
        card.setAttribute('aria-pressed', String(selected && !marketHidden));
        card.setAttribute('aria-disabled', String(disabled));
        card.tabIndex = marketHidden ? -1 : 0;
        if (selected && !marketHidden) selectedLabel = value;
      });
      const label = group.querySelector('[data-wn-smart-selection]');
      if (label && selectedLabel) label.textContent = selectedLabel;
    });
  }

  function selectOption(guide, button) {
    if (button.hidden || button.getAttribute('aria-disabled') === 'true') return;
    const form = guide.closest('wn-product-form');
    if (!form) return;

    const position = Number(button.dataset.wnGuidePosition || 0);
    const value = button.dataset.wnGuideValue || '';
    const native = nativeOptionButton(form, position, value);

    if (native && !native.hidden && native.getAttribute('aria-hidden') !== 'true') {
      native.click();
      syncCards(guide, form);
      return;
    }

    const variant = variantForChoice(form, position, value);
    if (!variant || !variant.available || typeof form.render !== 'function') return;
    form.render(variant, true);
    syncCards(guide, form);
  }

  function boot(root = document) {
    root.querySelectorAll('[data-wn-guided-choice]').forEach((guide) => {
      if (guide.dataset.wnGuideReady === 'true') return;
      guide.dataset.wnGuideReady = 'true';
      const form = guide.closest('wn-product-form');
      if (!form) return;

      const nativeOptions = form.querySelector('[data-product-options]');
      if (nativeOptions) {
        nativeOptions.setAttribute('aria-hidden', 'true');
        nativeOptions.querySelectorAll('button, input, select').forEach((control) => control.setAttribute('tabindex', '-1'));
      }

      const sync = () => requestAnimationFrame(() => syncCards(guide, form));
      syncCards(guide, form);
      form.addEventListener('wn:product:variant-change', sync);
      document.addEventListener('wn:market-options-filtered', sync);
      window.setTimeout(sync, 0);
      window.setTimeout(sync, 120);

      guide.addEventListener('click', (event) => {
        const option = event.target.closest('[data-wn-guide-option]');
        if (!option) return;
        event.preventDefault();
        selectOption(guide, option);
      });
    });
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
})();
